<template>
  <b-row class="d-flex justify-content-around p-2" style="margin: auto;">
    <b-col md="10" class="text-left">
      <h1 :style="myStyle">Organizzazioni Accreditate</h1>
      <br />
      <b-row id="wrapper">
        <b-col
          class="text-center logo-organizzazione"
          md="3"
          v-for="organization in organizations"
          :key="organization.id"
        >
          <b-img
            v-if="organization.image !== null"
            align-self="center"
            :src="logo(organization)"
            v-bind="mainProps"
            rounded="circle"
            :alt="organization.name"
          />
          <b-img v-else v-bind="emptyProps" rounded="circle" :alt="organization.name" />

          <div>
            <h4 :style="myStyle">
              {{ organization.name }}
            </h4>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import util from "@/mixing/util";
import UserService from "@/services/user.service";

export default {
  mixins: [util],
  data() {
    return {
      organizations: [],
      languages: [],
      myStyle: {
        textAlign: "center",
      },
      mainProps: {
        blankColor: "#777",
        width: 125,
        height: 125,
        class: "m1",
      },
      emptyProps: {
        blank: true,
        blankColor: "#777",
        width: 125,
        height: 125,
        class: "m1",
      },
    };
  },
  mounted() {
    UserService.getOrganizations().then((response) => (this.organizations = response.data));
    
    if(localStorage.dest_lang)
      localStorage.removeItem('dest_lang');
  },
  methods: {
    logo: function (org) {
      return process.env.VUE_APP_ROOT + "/" + org.image;
    },
  },
};
</script>

<style scoped>
.logo-organizzazione {
  min-height: 300px;
}
</style>
